import { PostAuthComponentParams } from '../../types/auth';
import { useIntl } from 'react-intl';
import ContainerLayout from '../ContainerLayout';
import {
  Button,
  Header,
  SpaceBetween,
  TextContent,
  Container,
} from '@amzn/awsui-components-react';
import autoLinkConsentMessages from '../../i18n/autoLinkConsent.messages';
import './autoLinkConsent.css';
import { providerMessages } from '../../i18n/provider.messages';
import { IdPs } from '../../constants/providers';
import configService from '../../services/config';

const AutoLinkConsent = ({
  user,
  onContinue,
  config,
}: PostAuthComponentParams) => {
  const { formatMessage, formatDate } = useIntl();
  const isHcUatSignIn = configService.isHcUATSignIn();
  if (
    user.autoLinkConsent === undefined ||
    (config.enableAutoLinkConsent !== 'true' && !isHcUatSignIn)
  ) {
    onContinue();
    return null;
  }

  const handaleSubmitButton = () => {
    onContinue();
  };

  return (
    <ContainerLayout>
      <Container>
        <SpaceBetween size={'l'} direction="vertical">
          <Header variant="h1" className="large-header">
            {formatMessage(autoLinkConsentMessages.pageTitle)}
          </Header>
          <TextContent>
            {formatMessage(autoLinkConsentMessages.pageDescription, {
              idp: providerMessages[user.autoLinkConsent?.idp as IdPs]
                .defaultMessage,
              email: user.email,
              date: formatDate(user.autoLinkConsent?.last_signed_in!, {
                dateStyle: 'long',
              }),
              b: (str) => <b>{str}</b>,
            })}
          </TextContent>
          <div className="button-right">
            <Button
              variant="primary"
              onClick={handaleSubmitButton}
              data-testid="continue-button"
            >
              {formatMessage(autoLinkConsentMessages.button)}
            </Button>
          </div>
        </SpaceBetween>
      </Container>
    </ContainerLayout>
  );
};

export default AutoLinkConsent;
